export var NumericField = {
    parts: ['numericInput'],
    baseStyle: {
        numericInput: {
            w: '50%',
        },
    },
};
